import React, {FC} from 'react';
import styled from 'styled-components';

import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {SettingsSearchSeeAllItemModel} from '../../../models/api/settingsSearchModel';
import {
  SettingsSearchDropdownContent,
  SettingsSearchDropdownItem,
  SettingsSearchDropdownItemLeftIcon,
  SettingsSearchDropdownTitle,
} from './settingsSearchCommon';
import {SettingsSearchDropdownItemBaseProps} from './settingsSearchCommonTypes';

/*
 * Props.
 */

interface SettingsSearchDropdownResourceSeeAllItemProps extends SettingsSearchDropdownItemBaseProps {
  item: SettingsSearchSeeAllItemModel;
}

/*
 * Style.
 */

const StyledSeeAllItem = styled(SettingsSearchDropdownItem)`
  padding: 8px 0;
  grid-template-columns: 14px auto auto 1fr auto auto 12px;
`;

const StyledLeftIcon = styled(SettingsSearchDropdownItemLeftIcon)`
  margin-right: 9px;

  > svg {
    height: 16px;
  }
`;

/*
 * Component.
 */

export const SettingsSearchDropdownSeeAllItem: FC<SettingsSearchDropdownResourceSeeAllItemProps> = (
  props,
) => {
  const theme = useUserTheme();

  return (
    <StyledSeeAllItem checkmarkLabel={props.item.title} onSelect={props.onSelect}>
      <StyledLeftIcon>
        <Icon name="searchSmall" color={theme.greys.shade70} />
      </StyledLeftIcon>
      <SettingsSearchDropdownContent>
        <SettingsSearchDropdownTitle>{props.item.title}</SettingsSearchDropdownTitle>
      </SettingsSearchDropdownContent>
    </StyledSeeAllItem>
  );
};
